"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var arrow_svg_1 = __importDefault(require("@assets/components/directory/directory-header/arrow.svg"));
var AppMargins_1 = require("../../../app/components/AppMargins");
var DirectoryInput_1 = __importDefault(require("./DirectoryInput"));
var appMargins_1 = __importDefault(require("../../../app/components/AppMargins/appMargins"));
var BetaTag_1 = __importDefault(require("../../../app/components/widgets/BetaTag"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        headerWrapper: {
            backgroundColor: theme.palette.primary.dark,
            position: 'sticky',
            top: 0,
        },
        headerWrapperShort: {
            backgroundColor: theme.palette.primary.dark,
            top: 0,
        },
        headerContent: (_a = {
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                top: '22px',
                margin: '0 auto',
                maxWidth: function (props) {
                    return theme.spacing(180) - 2 * props.appMargins;
                }
            },
            _a[theme.breakpoints.up('md')] = {
                top: '35px',
            },
            _a),
        headerTextWrapper: {
            color: theme.palette.background.default,
            marginBottom: theme.spacing(3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        headerText: (_b = {
                flexShrink: 0,
                marginRight: theme.spacing(2)
            },
            _b[theme.breakpoints.up('md')] = {
                marginRight: theme.spacing(1),
            },
            _b),
        leftWrapper: {
            display: 'flex',
            alignItems: 'center',
        },
        rightWrapper: {
            display: 'inline-flex',
        },
        arrow: {
            paddingRight: '5px',
        },
    });
});
/**
 * @component Header bar that holds the search input bar and user page redirection button.
 */
var DirectoryHeader = function (_a) {
    var onQueryChange = _a.onQueryChange, onSortOrderChange = _a.onSortOrderChange, onClearQuery = _a.onClearQuery, query = _a.query, getFile = _a.getFile, getState = _a.getState, getEmail = _a.getEmail, onApply = _a.onApply, onReset = _a.onReset, setDisablePagination = _a.setDisablePagination;
    var appMargins = (0, appMargins_1.default)();
    var classes = useStyles({ appMargins: appMargins });
    var theme = (0, core_1.useTheme)();
    var isMobileView = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    // smaller then 730px height will cause the filter modal to be inaccessible
    var isIdealHeight = (0, core_1.useMediaQuery)('(min-height: 730px)');
    return (react_1.default.createElement("div", { className: isIdealHeight ? classes.headerWrapper : classes.headerWrapperShort },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement("div", { className: classes.headerContent },
                react_1.default.createElement("div", { className: classes.headerTextWrapper },
                    react_1.default.createElement("div", { className: classes.leftWrapper },
                        react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h4' : 'h2', className: classes.headerText }, "Search directory"),
                        react_1.default.createElement(BetaTag_1.default, null)),
                    react_1.default.createElement(core_1.Hidden, { xsDown: true },
                        react_1.default.createElement("div", { className: classes.rightWrapper },
                            react_1.default.createElement(core_1.Button, { href: "/#/user", size: "large", variant: "text", color: "inherit" },
                                react_1.default.createElement("img", { className: classes.arrow, src: arrow_svg_1.default, alt: "arrow graphic" }),
                                "Back to Dashboard")))),
                react_1.default.createElement(DirectoryInput_1.default, { showAdornments: true, onQueryChange: onQueryChange, query: query, onSortOrderChange: onSortOrderChange, onClearQuery: onClearQuery, getFile: getFile, getState: getState, getEmail: getEmail, onApply: onApply, onReset: onReset, setDisablePagination: setDisablePagination, onKeyPress: function (e) {
                        if (e.key === 'Enter') {
                            ;
                            e.target.blur();
                            e.preventDefault();
                        }
                    } })))));
};
exports.default = DirectoryHeader;
